import React, { useContext, useEffect, useState } from 'react';
import { Card, Tab } from 'semantic-ui-react';
import NotSavedModal from '../../../../components/notSavedModal';
import { AuthContext, CompanyAuthContext } from '../../../../App';
import { ROLES } from '../../../../constnats/user';
import AuthService from '../../../../service/auth';
import SchemaUtil from '../../../../utils/schemaUtil';
import PaneNameFactory from '../../../../utils/tabPaneNameFactory';
import ReportsWrapper from './financialTables/reportsWrapper';
import { DoubleMap } from '../../../../structures/doubleMap';
import { Description } from '../../../../components/company/description';
import { ExternalResourcesCard } from '../../../../components/company/externalLinkResources';
import { SchemasContext } from '../../../../contexts/schemaContext';
import TableUpdateContextProvider from '../../../../components/tableUpdateContextProvider/tableUpdateContextProvider';
import ReportsRepo from '../../../../utils/repository/repoertsRepo';
import { PeerBranchesProvider } from '../contexts/peersReportsContext';
import { BranchSettingContext } from '../../../../contexts/branchSettingsContext';
import { TableUpdateContext } from '../../../../contexts/reviewTypeContext';
import { ReviewType } from '../../../../components/financialTables/configuration/constants';
import { SchemaDiffUtil } from '../../../../utils/schemaDiffUtil';
import { SUPPORTED_DATA } from '../stores/peersReportsStore/constants';

class CompanyReportsInternal extends React.Component {

    constructor(props, context) {
        super(props);

        this.setDirty = this.setDirty.bind(this);

        const { panes, schemaToPane } = this.getPanes(context);
        this.schemaToPane = schemaToPane;
        this.panes = panes;

        const paneId = schemaToPane.getValueByKey(
            this.props.tabsContext.getSchemaId());
        const activeIndex = paneId === null ? 0 : paneId;

        this.state = {
            activeIndex,
            confirmationModal: <></>,
        };

        this.dirtyTab = false;
    }

    setDirty = (dirty) => {
        this.dirtyTab = dirty;
        this.props.setDirty(dirty);
    }

    handleTabChange = (e, { activeIndex }) => {
        if (this.dirtyTab === false) {
            this.setState({ activeIndex });
            this.props.tabsContext.setSchemaId(this.schemaToPane.getKeyByValue(activeIndex));
        } else {
            this.setState({
                confirmationModal: <NotSavedModal onConfirm={() => this.setState({ confirmationModal: <></> })} />
            });
        }
    };

    getPanes(context) {
        const company = this.props.company;
        const companyId = company.id;
        const schemaToPane = new DoubleMap();
        const schemas = company.schemas;
        const panes = company.schemas
            .sort(SchemaUtil.comapreSchemas).map((schema, i) => {
                schemaToPane.add(schema.id, i);
                return {
                    menuItem: PaneNameFactory.forSchema(schema),
                    render: () => (
                        <SchemasContext.Provider value={schemas}>
                            <TableUpdateContextProvider currentSchema={schema}>
                                <Pane schema={schema} context={context} companyId={companyId}
                                    currency={company.currency} setDirty={this.setDirty} />
                            </TableUpdateContextProvider>
                        </SchemasContext.Provider>

                    )


                };
            });

        return { panes, schemaToPane };
    }

    render() {

        return (
            <div className='reportTabsContainer'>
                {this.state.confirmationModal}
                <Tab className="reportTabs centeredPanesCollection"
                    panes={this.panes}
                    onTabChange={this.handleTabChange}
                    activeIndex={this.state.activeIndex}
                    menu={{
                        pointing: true,
                        secondary: true,
                        attached: true,
                        tabular: true,
                        style: {
                            display: "flex",
                            paddingBottom: "6px"
                        }
                    }}
                />
                <Card.Group className="companyCardGroup">
                    <Description description={this.props.company.description} />
                    <ExternalResourcesCard company={this.props.company} />
                </Card.Group>
            </div>
        );
    }
}

function getSupportedDataTypes(reviews, peerSchemaId) {
    const currentReview = reviews.find((r) => r.schemaId === peerSchemaId);
    return currentReview?.type === ReviewType.CORE_DATA_CHECK
        ? [SUPPORTED_DATA.CD]
        : [SUPPORTED_DATA.CD, SUPPORTED_DATA.FIELD_SRC, SUPPORTED_DATA.REPORTED_AS_LABELS];
}

//TODO Relocate
function usePeerBranches(schema) {
    const schemaContext = useContext(SchemasContext);
    const tableUpdateContext = useContext(TableUpdateContext)
    const [peerBranches, setPeerBranches] = useState([]);

    useEffect(() => {
        const controller = new AbortController()

        const peersSchemas = schema.branchType === "MAIN" ? [] : schemaContext
            .filter((s) => s.name === schema.name && s.id !== schema.id && s.branchType != "MAIN");

        const promises = peersSchemas.map((peerSchema) => {
            return new Promise((resolve) => {
                ReportsRepo.listBySchema(peerSchema.id, (reports) => {
                    const { diffs, descriptorPairs } = SchemaDiffUtil.schemaDiff(schema, peerSchema, { labelsAndTypesOnly:true })
                    const descriptorMappings = {}
                    if (diffs.length === 0) {
                        for (const pair of descriptorPairs) {
                            descriptorMappings[pair.editBranchDesc.id] = pair.reviewBranchDesc.id
                        }
                    } 

                    resolve({
                        schemaId: peerSchema.id,
                        schemaName: peerSchema.name,
                        branchName: peerSchema.branchType,
                        branchSupportedData: getSupportedDataTypes(tableUpdateContext.reviews, peerSchema.id),
                        descriptorMappings,
                        reports: reports
                    });
                });
            });
        });
        Promise.all(promises).then((result) => {
            if (!controller.signal.aborted) {
                setPeerBranches(result);
            }
        });

        return () => {
            controller.abort()
            setPeerBranches([]);
        };

    }, [schema, schemaContext, tableUpdateContext.reviews]);

    return { peerBranches };
}

function Pane({ schema, context, companyId, currency, setDirty }) {
    const { peerBranches } = usePeerBranches(schema);
    const tableUpdateContext = useContext(TableUpdateContext)
    const branchSettings = useContext(BranchSettingContext)
    const fullReadPermissions = AuthService.hasRole(context, ROLES.READ_ALL_MODELS_AND_REPORTS);
    const isUserQa = AuthService.hasRole(context, ROLES.QA);
    const userId = AuthService.getUserId();
    // TODO: move permissions to branch settings context
    const calcPemissions = schema => {
        let permissions = "no";
        if (schema.visibility !== "SYSTEM") {
            if (schema.branchType === "MAIN") {
                permissions = "readOnly";
            } else {
                if (userId === schema.owner.id) {
                    permissions = "edit";
                } else if (fullReadPermissions === true || (isUserQa
                    && branchSettings.permissions.qa.read)) {
                    permissions = "readOnly";
                }
            }
        }

        return permissions;
    };
    const permissions = calcPemissions(schema);

    return (
        <Tab.Pane>
            <div style={{ padding: 15, textAlign: 'center', fontWeight: 'bold' }}>{branchSettings.branchSubtitle}</div>
            {permissions === "no" ?
                <>Not enough privileges!</> :
                <PeerBranchesProvider
                    currentSchemaId={schema.id}
                    currentBranchSupportedData={branchSettings.supportedData}
                    peerBranches={peerBranches}
                    events={tableUpdateContext.reconciliationEvents} >
                    <ReportsWrapper key={schema.id}
                        schema={schema}
                        readOnly={permissions === "readOnly"}
                        companyId={companyId}
                        currency={currency}
                        setDirty={setDirty} />
                </PeerBranchesProvider>
            }
        </Tab.Pane>
    );
}

CompanyReportsInternal.contextType = CompanyAuthContext;

export default function Reports({ company, setIsDirty, tabsContext }) {
    const authContext = Object.assign({}, React.useContext(AuthContext));
    authContext.entityId = company.id;

    return <CompanyAuthContext.Provider value={authContext}>
        <CompanyReportsInternal company={company} setDirty={setIsDirty}
            tabsContext={tabsContext} />
    </CompanyAuthContext.Provider>;
}